import qs from "qs";
import { useEffect, useState } from "react";

import useLocation from "@brexhq/next/src/hooks/useLocation";

export const usePreviewEnvironment = () => {
  const [previewEnvironmentNamespace, setPreviewEnvironmentNamespace] =
    useState<string | undefined>(undefined);
  const location = useLocation();

  const search = location?.search;
  useEffect(() => {
    const queryParams: any = search
      ? qs.parse(search, {
          ignoreQueryPrefix: true,
        })
      : {};

    if (queryParams.previewEnvironmentNamespace) {
      setPreviewEnvironmentNamespace(queryParams.previewEnvironmentNamespace);
    }
  }, [search]);

  return { previewEnvironmentNamespace };
};
